// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { itemDetailSchema } from '@/items/api/types';
import { ItemFieldType } from '@/items/constants/item-field-types';
import { z } from 'zod';

interface CreateItemFieldParameters {
  label: string;
  fieldType: ItemFieldType;
  order: number;
  section: number;
}

const createItemFieldResponseSchema = z
  .object({ data: itemDetailSchema, metadata: responseMetadataSchema })
  .transform(({ data, ...response }) => ({ ...response, item: data }));

type CreateItemFieldResponse = z.infer<typeof createItemFieldResponseSchema>;

/**
 * Creates a new field for an item.
 */
export async function createItemField(
  itemKey: string,
  parameters: CreateItemFieldParameters
): Promise<CreateItemFieldResponse> {
  const url = `/v1/catalog/item/${itemKey}/field`;
  const response = await api.post(url, parameters);
  return parseResponse(createItemFieldResponseSchema, response.data, {
    schemaName: 'CreateItemField',
    endpoint: url,
  });
}
